import styled from "styled-components"

export const TermsAndConditionsImage = styled.object`
  object-fit: cover;
  max-width: 20%;
`
